
import React, {Component} from 'react';
import {Button} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import SWTNewColorModal from './SWTNewColorModal'

class SWTNewColorButton extends Component {

  constructor(...args){
    super(...args)
    this.state = {show:false}
  }

  onClick(){
    this.refs.newColorPop.openPopup()
    this.setState({show:true})
  }

  render(){
    let {show} = this.state
    return (
      <div>        
        <Button  onClick={this.onClick.bind(this)}><FontAwesome name='plus'/></Button>
        <SWTNewColorModal ref={'newColorPop'} show={show} 
        onChange={this.props.onChange}
        onHide={()=>{this.setState({show:false})}}/>
      </div>
    )
  }
}


export default SWTNewColorButton;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTNewColorButton.js